import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { VStack } from "@whoosh/design-system/src/components/primitive";

import { PlayerList_Booking$key } from "./__generated__/PlayerList_Booking.graphql";
import { OtherPlayersInThisBooking } from "./components/OtherPlayersInThisBooking/OtherPlayersInThisBooking";

export const PlayerList = ({
  bookingRef,
}: {
  bookingRef: PlayerList_Booking$key | null;
}) => {
  const booking = useFragment(PlayerListBookingFragmentString, bookingRef);
  return (
    <VStack padding={5} backgroundColor="surface-primary">
      <OtherPlayersInThisBooking bookingRef={booking ?? null} />
    </VStack>
  );
};

const PlayerListBookingFragmentString = graphql`
  fragment PlayerList_Booking on Booking {
    ...OtherPlayersInThisBooking_Booking
  }
`;
